import { type FC } from 'react';
import classnames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { type DesignsLayout_viewer$data as Viewer } from './__generated__/DesignsLayout_viewer.graphql.ts';

// components
import { PageLayout } from 'dibs-elements/exports/PageLayout.tsx';
import { DesignsCarousel } from './DesignsCarousel/DesignsCarousel.tsx';
import { DesignsDirectory } from './DesignsDirectory/DesignsDirectory.tsx';
import { DesignsBreadcrumbs } from './DesignsBreadcrumbs/DesignsBreadcrumbs.tsx';
import { DesignsFeaturedItems } from './DesignsFeaturedItems/DesignsFeaturedItems.tsx';

// styles
import styles from './DesignsLayout.scss';

type Props = {
    viewer: Viewer;
    isMobile: boolean;
};

const DesignsLayoutComponent: FC<Props> = ({ viewer, isMobile }) => {
    if (!viewer.iconicDesignsDirectoryPage) {
        return null;
    }

    return (
        <PageLayout setOffset={!isMobile} setViewportBackground>
            <DesignsBreadcrumbs />
            <div
                className={classnames({
                    [styles.container]: !isMobile,
                })}
            >
                <DesignsCarousel
                    isMobile={isMobile}
                    iconicDesignsDirectoryPage={viewer.iconicDesignsDirectoryPage}
                />
                <DesignsFeaturedItems
                    isMobile={isMobile}
                    iconicDesignsDirectoryPage={viewer.iconicDesignsDirectoryPage}
                />
                <DesignsDirectory
                    viewer={viewer}
                    isMobile={isMobile}
                    iconicDesignsDirectoryPage={viewer.iconicDesignsDirectoryPage}
                />
            </div>
        </PageLayout>
    );
};

export const DesignsLayout = createFragmentContainer(DesignsLayoutComponent, {
    viewer: graphql`
        fragment DesignsLayout_viewer on Viewer {
            ...DesignsDirectory_viewer
            iconicDesignsDirectoryPage {
                ...DesignsCarousel_iconicDesignsDirectoryPage
                ...DesignsDirectory_iconicDesignsDirectoryPage
                ...DesignsFeaturedItems_iconicDesignsDirectoryPage
            }
        }
    `,
});
